import { render } from "./Water.vue?vue&type=template&id=b0a16740"
import script from "./Water.vue?vue&type=script&lang=js"
export * from "./Water.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gimmetm/work/projects/tnms-go/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__